import React,{ useEffect, useState } from 'react'
import moment from 'moment'
import {rangeFromYearAndMonth} from '../timeConversion'
import {createComment,saveComment,fetchComments,deleteComment} from '../data-source/comments' 

const CommentsContext = React.createContext([])
export const CommentsConsumer = CommentsContext.Consumer



export const CommentsProvider = ({year,month,children,errorHandler = () => {}}) => {
    const [comments,setComments] = useState([])

    const fetchEffect = () => {
        const range = rangeFromYearAndMonth(year,month)
        fetchComments(range.start,moment().add(1,'h').format())
            .then( fetchedComments => {
                setComments(fetchedComments)
            })
            .catch( errorHandler )
    
    }

    useEffect( fetchEffect , [year,month,setComments,errorHandler])

    const saveHandler = (commentId,data) => {
        if(data.justSaved) delete data.justSaved;
        if(data.formatted_date) delete data.formatted_date;
        if(data.author_name) delete data.author_name;

        const commentErrorHandler = e => {
            setComments([...comments,{
                ...data,
                id: commentId,
                date:  moment().format('YYYY-MM-DD H:mm'),
                error: e
            }])
            errorHandler(e)
        }

        if(commentId === 0){
            createComment(data)
                .then( fetchEffect )
                .catch( commentErrorHandler )

            setComments([...comments,{
                ...data,
                id: comments.length + 1000,
                date:  moment().format('YYYY-MM-DD H:mm'),
                justSaved: true
            }])
            
            
        }else{

            saveComment(commentId,data)
                .then( fetchEffect )
                .catch( commentErrorHandler )

            setComments( comments.map( c => {
                if( c.id === commentId ){
                    return {...c, ...data, justSaved: true,};
                }
                return c;
            }))
        }
    }

    const deleteHandler = (commentId) => {
        if( commentId !== 0 ){
            deleteComment(commentId)
                .catch( errorHandler )
        }
        setComments( comments.filter( c => c.id !== commentId ))
    }

    return(<CommentsContext.Provider value={{comments: comments, saveHandler: saveHandler, deleteHandler: deleteHandler}}>{children}</CommentsContext.Provider>);
}

export default CommentsContext;